import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { OccConfig } from '@spartacus/core'
import { finalize, switchMap, take } from 'rxjs/operators'
import { CreditClaimsService } from '../../../../services/creditClaims/credit-claims.service'
import { SharedService } from '../../../../services/shared/shared.service'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { ActivatedRoute } from '@angular/router'
import { LaunchDialogService } from '@spartacus/storefront'
import { CreditClaim } from '../../../../models/credit-claims.model'
import { LAUNCH_CALLER } from '../../../../models/enum/custom-dialog.enum'

@Component({
  selector: 'app-credit-claims-details',
  templateUrl: './credit-claims-details.component.html',
  styleUrls: ['./credit-claims-details.component.scss'],
  standalone: false
})
export class CreditClaimsDetailsComponent implements OnInit {
  public creditClaimCode: string
  public creditClaim: CreditClaim
  public showInitialLoader = true
  public pdfURL: string

  modalRef: any

  public headers: ICustomTableHeader[] = [
    { title: 'shared.sku' },
    { title: 'creditClaims.order.description' },
    { title: 'creditClaims.order.deliveredQTY' },
    { title: 'creditClaims.order.claimQTY' },
    { title: 'creditClaims.order.itemValue' },
    { title: 'creditClaims.order.totalValue' }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'productCode' },
    { key: 'productDescription' },
    { key: 'deliveredQuantity' },
    { key: 'claimQuantity' },
    { key: 'formattedItemPrice' },
    { key: 'formattedTotalPrice' }
  ]

  constructor(
    public occConfig: OccConfig,
    public creditClaimsService: CreditClaimsService,
    public sharedService: SharedService,
    private changeDetectorRef: ChangeDetectorRef,
    private launchDialogService: LaunchDialogService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.sharedService
      .getUrlParam('code')
      .pipe(
        switchMap((code) => {
          this.creditClaimCode = code
          return this.route.queryParams.pipe(
            switchMap((res) => {
              return this.creditClaimsService.getCreditClaimDetail(code, { distributorNo: res.distributorNo })
            })
          )
        }),
        finalize(() => {
          this.showInitialLoader = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((detail) => {
        this.creditClaim = detail
        this.showInitialLoader = false
        this.changeDetectorRef.detectChanges()
      })
  }

  getResolutionDocumentUrl(creditClaim: CreditClaim): void {
    this.pdfURL = this.getPdfUrl(creditClaim)
    window.open(this.pdfURL, '_self')
  }

  public getPdfUrl(creditClaim: CreditClaim): string {
    const baseUrl = this.occConfig.backend.occ.baseUrl
    const urls = creditClaim.resolutionDocumentUrl.split('?')
    if (urls.length >= 2) {
      return baseUrl + urls[0] + creditClaim.invoiceNumber + '.pdf?' + urls[1] + '&attachment=true'
    }
    return null
  }

  public showAttachments(creditClaim: CreditClaim): void {
    const dialog = this.launchDialogService.openDialog(
      LAUNCH_CALLER.CUSTOM_OPEN_CREDIT_CLAIM_ATTACHMENTS,
      null,
      null,
      creditClaim
    )

    dialog?.pipe(take(1)).subscribe()
  }
}
